import { safeReturnTo } from "@mycompbox/shared";

/** sessionStorage key for where a signed-out visitor goes once they sign in. */
export const POST_LOGIN_RETURN_TO_KEY = "compbox.auth.returnTo";

/** Remember a same-origin path to come back to after signing in. */
export function rememberPostLoginReturnTo(path: string): void {
  const safe = safeReturnTo(path);
  if (!safe) return;
  try {
    sessionStorage.setItem(POST_LOGIN_RETURN_TO_KEY, safe);
  } catch {
    // Storage blocked: sign-in lands on the dashboard instead.
  }
}

/** Read and clear the remembered path; null when none (or unsafe). */
export function takePostLoginReturnTo(): string | null {
  try {
    const value = safeReturnTo(sessionStorage.getItem(POST_LOGIN_RETURN_TO_KEY));
    sessionStorage.removeItem(POST_LOGIN_RETURN_TO_KEY);
    return value;
  } catch {
    return null;
  }
}
